import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 18px;
  width: 18px;
`
export const FilterIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.95828 17.3346C7.66314 17.3346 7.41574 17.2348 7.21609 17.0352C7.01644 16.8355 6.91661 16.5881 6.91661 16.293V10.043L0.692654 2.10026C0.449599 1.80512 0.414876 1.49262 0.588487 1.16276C0.762099 0.832899 1.0312 0.667969 1.39578 0.667969H16.6041C16.9687 0.667969 17.2378 0.832899 17.4114 1.16276C17.585 1.49262 17.5503 1.80512 17.3072 2.10026L11.0833 10.043V16.293C11.0833 16.5881 10.9835 16.8355 10.7838 17.0352C10.5841 17.2348 10.3368 17.3346 10.0416 17.3346H7.95828ZM8.99995 10.1471L15.2499 2.23047H2.74995L8.99995 10.1471Z"
        fill="#916EE8"
      />
    </Svg>
  )
}
